import { render } from "./Table5Charts.vue?vue&type=template&id=4d2d77bc&scoped=true"
import script from "./Table5Charts.vue?vue&type=script&lang=js"
export * from "./Table5Charts.vue?vue&type=script&lang=js"

import "./Table5Charts.vue?vue&type=style&index=0&id=4d2d77bc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2d77bc"]])

export default __exports__